import { gql } from '@/apollo';

export const ARCHIVE_TRACE_STATES_MUTATION = gql(`
  mutation archiveTraceStatesMutation(
    $traceIds: [UUID!]!
    $archived: Boolean!
    $manuallyEdited: Boolean
  ) {
    archiveTraceStates(
      input: {
        traceIds: $traceIds
        archived: $archived
        manuallyEdited: $manuallyEdited
      }
    ) {
      updatedTraceIds
    }
  }
`);
